import { useState } from "react";
import { C, font } from "../tokens";

// Formulário multi-etapas IDÊNTICO ao de /agendar-demo (mesmos passos, campos,
// opções, máscara de telefone, validação e webhook do CRM). Reutilizado no modal
// de exit-intent. Mantém a página /agendar-demo intacta.

const WEBHOOK =
  "https://crm.imobmeet.com.br/webhook/formulario/9d194cd68c0dbec04dd51600b07909d37b88461f";

const STEPS = ["Sobre você", "Sua operação", "O que busca"];
const CARGOS = ["Sócio/Proprietário", "Gestor Comercial", "Gestor de Marketing", "Corretor", "Gestor de TI", "Supervisor", "Outros"];
const SEGMENTOS = ["Loteadora", "Incorporadora Médio/Alto Padrão", "Incorporadora MCMV", "Agência/Consultoria", "Coordenação de Vendas", "Lançadora", "Agência de Publicidade", "Consultoria", "Corretor", "Outros"];
const DESAFIOS = ["Gestão de Leads e Atendimentos", "Gestão de Disponibilidade e Reservas", "Propostas/Reservas e integrações ERP", "Relatórios e indicadores", "Todo o processo de vendas", "Pós-vendas", "Outros"];
const EMPREENDIMENTOS = ["Nenhum", "1 a 3 empreendimentos", "4 a 10 empreendimentos", "11 a 20 empreendimentos", "21 a 30 empreendimentos", "Mais de 30 empreendimentos"];
const INTERESSES = ["CRM", "Gestão de Recebíveis", "HUB Whatsapp", "Pagadoria inteligente", "Auto Vendas"];

const PAISES = [
  { c: "BR", dial: "55", flag: "🇧🇷" }, { c: "PT", dial: "351", flag: "🇵🇹" },
  { c: "US", dial: "1", flag: "🇺🇸" }, { c: "AR", dial: "54", flag: "🇦🇷" },
  { c: "MX", dial: "52", flag: "🇲🇽" }, { c: "CL", dial: "56", flag: "🇨🇱" },
  { c: "CO", dial: "57", flag: "🇨🇴" }, { c: "PY", dial: "595", flag: "🇵🇾" },
  { c: "UY", dial: "598", flag: "🇺🇾" }, { c: "ES", dial: "34", flag: "🇪🇸" },
  { c: "IT", dial: "39", flag: "🇮🇹" },
];

const maskBR = (v) => {
  const t = v.replace(/\D/g, "").slice(0, 11);
  if (!t) return "";
  if (t.length <= 2) return `(${t}`;
  if (t.length <= 6) return `(${t.slice(0, 2)}) ${t.slice(2)}`;
  if (t.length <= 10) return `(${t.slice(0, 2)}) ${t.slice(2, 6)}-${t.slice(6)}`;
  return `(${t.slice(0, 2)}) ${t.slice(2, 7)}-${t.slice(7, 11)}`;
};
const maskIntl = (v) => v.replace(/\D/g, "").slice(0, 15).replace(/(\d{3})(?=\d)/g, "$1 ").trim();

const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: 10,
  border: `1.5px solid ${C.border}`,
  fontFamily: font,
  fontSize: 15,
  outline: "none",
  background: C.surface,
  color: C.text,
  boxSizing: "border-box",
};
const labelStyle = {
  display: "block",
  fontFamily: font,
  fontSize: 12,
  fontWeight: 700,
  color: C.muted,
  textTransform: "uppercase",
  letterSpacing: 0.4,
  marginBottom: 7,
};

const Check = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

const focus = (e) => (e.target.style.borderColor = C.accent);
const blur = (e) => (e.target.style.borderColor = C.border);

function Field({ label, children }) {
  return (
    <div>
      <label style={labelStyle}>{label}</label>
      {children}
    </div>
  );
}

function PhoneInput({ onChange }) {
  const [dial, setDial] = useState("55");
  const [val, setVal] = useState("");
  const apply = (d, raw) => {
    const masked = d === "55" ? maskBR(raw) : maskIntl(raw);
    setDial(d);
    setVal(masked);
    onChange(masked ? `+${d} ${masked}` : "");
  };
  return (
    <div style={{ display: "flex", gap: 8 }}>
      <select
        value={dial}
        onChange={(e) => apply(e.target.value, val)}
        onFocus={focus}
        onBlur={blur}
        aria-label="Código do país"
        style={{ ...inputStyle, width: "auto", flexShrink: 0, padding: "12px 8px", fontSize: 14.5, cursor: "pointer" }}
      >
        {PAISES.map((p) => (
          <option key={p.c} value={p.dial}>{p.flag} +{p.dial}</option>
        ))}
      </select>
      <input
        type="tel"
        required
        inputMode="numeric"
        value={val}
        onChange={(e) => apply(dial, e.target.value)}
        onFocus={focus}
        onBlur={blur}
        style={inputStyle}
        placeholder={dial === "55" ? "(00) 00000-0000" : "000 000 000"}
      />
    </div>
  );
}

export default function DemoStepsForm({ onClose, onSubmitted, origem = "popup-exit-intent" }) {
  const [form, setForm] = useState({
    nome: "", email: "", telefone: "", site: "", empresa: "",
    cargo: "", segmento: "", desafio: "", empreendimentos: "", interesses: [],
  });
  const [step, setStep] = useState(0);
  const [sent, setSent] = useState(false);
  const last = STEPS.length - 1;

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const toggle = (v) =>
    setForm((f) => ({
      ...f,
      interesses: f.interesses.includes(v) ? f.interesses.filter((x) => x !== v) : [...f.interesses, v],
    }));

  const send = () => {
    try {
      const fd = new FormData();
      fd.append("Nome", form.nome);
      fd.append("Email", form.email);
      fd.append("Telefone", form.telefone);
      fd.append("Site", form.site);
      fd.append("Empresa", form.empresa);
      fd.append("Cargo", form.cargo);
      fd.append("Segmento", form.segmento);
      fd.append("Principal_Desafio", form.desafio);
      fd.append("Empreendimentos_Lancados", form.empreendimentos);
      fd.append("Interesse", form.interesses.join(", "));
      new URLSearchParams(window.location.search).forEach((v, k) => fd.append(k, v));
      fd.append("page_url", window.location.href);
      fd.append("page_title", document.title);
      fd.append("origem", origem);
      fetch(WEBHOOK, { method: "POST", body: fd, keepalive: true }).catch(() => {});
      // Conversão do Google Ads (envio de formulário de lead)
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
          send_to: "AW-17079459254/-HfrCJbQ24EbELa7j9A_",
        });
      }
    } catch {}
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (step < last) setStep(step + 1);
    else {
      send();
      // Se o pai controla o estado de sucesso (ex.: página /agendar-demo com
      // sucesso de página inteira), delega; senão mostra o sucesso compacto.
      if (onSubmitted) onSubmitted(form);
      else setSent(true);
    }
  };

  if (sent) {
    return (
      <div style={{ textAlign: "center", padding: "18px 0" }}>
        <div style={{ width: 62, height: 62, borderRadius: "50%", background: "#ECFDF5", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", color: "#10B981" }}>
          <Check size={30} />
        </div>
        <h3 style={{ fontFamily: font, fontSize: 22, fontWeight: 800, color: C.text, margin: "0 0 10px", letterSpacing: -0.4 }}>
          Recebemos seu contato!
        </h3>
        <p style={{ fontFamily: font, fontSize: 15, lineHeight: 1.6, color: C.muted, margin: "0 0 24px" }}>
          Nossa equipe vai falar com você em breve para agendar a sua demonstração do IMOBMEET.
        </p>
        {onClose && (
          <button onClick={onClose} style={{ fontFamily: font, fontSize: 15, fontWeight: 800, color: "#fff", background: C.accent, border: "none", borderRadius: 11, padding: "13px 28px", cursor: "pointer" }}>
            Fechar
          </button>
        )}
      </div>
    );
  }

  const submitDisabled = step === last && form.interesses.length === 0;

  return (
    <>
      {/* Indicador de passos */}
      <div style={{ display: "flex", alignItems: "flex-start", marginBottom: 24 }}>
        {STEPS.map((label, j) => (
          <div key={label} style={{ display: "contents" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 7, flex: "0 0 auto", width: 84 }}>
              <div
                style={{
                  width: 34, height: 34, borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: font, fontWeight: 800, fontSize: 14,
                  background: j <= step ? C.accent : C.bgAlt,
                  color: j <= step ? "#fff" : C.muted,
                  border: j <= step ? "none" : `1px solid ${C.border}`,
                  transition: "background 0.25s, color 0.25s",
                }}
              >
                {j < step ? <Check /> : j + 1}
              </div>
              <span style={{ fontFamily: font, fontSize: 11.5, fontWeight: 700, textAlign: "center", color: j === step ? C.text : C.muted, lineHeight: 1.2 }}>
                {label}
              </span>
            </div>
            {j < last && (
              <div style={{ flex: 1, height: 2, marginTop: 16, background: j < step ? C.accent : C.border, transition: "background 0.25s" }} />
            )}
          </div>
        ))}
      </div>

      <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {step === 0 && (
          <>
            <Field label="Nome completo">
              <input type="text" name="Nome" required value={form.nome} onChange={set("nome")} onFocus={focus} onBlur={blur} style={inputStyle} placeholder="Seu nome" />
            </Field>
            <Field label="E-mail corporativo">
              <input type="email" name="Email" required value={form.email} onChange={set("email")} onFocus={focus} onBlur={blur} style={inputStyle} placeholder="voce@empresa.com.br" />
            </Field>
            <Field label="Telefone / WhatsApp">
              <PhoneInput onChange={(v) => setForm((f) => ({ ...f, telefone: v }))} />
            </Field>
            <Field label="Site">
              <input type="text" name="Site" value={form.site} onChange={set("site")} onFocus={focus} onBlur={blur} style={inputStyle} placeholder="www.suaempresa.com.br" />
            </Field>
            <Field label="Empresa">
              <input type="text" name="Empresa" required value={form.empresa} onChange={set("empresa")} onFocus={focus} onBlur={blur} style={inputStyle} placeholder="Nome da empresa" />
            </Field>
          </>
        )}

        {step === 1 && (
          <>
            <Field label="Cargo">
              <select required name="Cargo" value={form.cargo} onChange={set("cargo")} onFocus={focus} onBlur={blur} style={inputStyle}>
                <option value="" disabled>Selecione o cargo</option>
                {CARGOS.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </Field>
            <Field label="Segmento">
              <select required name="Segmento" value={form.segmento} onChange={set("segmento")} onFocus={focus} onBlur={blur} style={inputStyle}>
                <option value="" disabled>Selecione o segmento</option>
                {SEGMENTOS.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </Field>
            <Field label="Principal desafio">
              <select required name="Principal_Desafio" value={form.desafio} onChange={set("desafio")} onFocus={focus} onBlur={blur} style={inputStyle}>
                <option value="" disabled>Selecione o desafio</option>
                {DESAFIOS.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </Field>
            <Field label="Quantos empreendimentos sua empresa já lançou?">
              <select required name="Empreendimentos_Lancados" value={form.empreendimentos} onChange={set("empreendimentos")} onFocus={focus} onBlur={blur} style={inputStyle}>
                <option value="" disabled>Selecione uma opção</option>
                {EMPREENDIMENTOS.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </Field>
          </>
        )}

        {step === 2 && (
          <Field label="O que você está buscando? (selecione um ou mais)">
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 10 }}>
              {INTERESSES.map((o) => {
                const on = form.interesses.includes(o);
                return (
                  <button
                    key={o}
                    type="button"
                    onClick={() => toggle(o)}
                    aria-pressed={on}
                    style={{
                      display: "flex", alignItems: "center", gap: 10,
                      padding: "13px 14px", borderRadius: 11, cursor: "pointer", textAlign: "left",
                      border: `1.5px solid ${on ? C.accent : C.border}`,
                      background: on ? `${C.accent}0D` : C.surface,
                      transition: "border-color 0.2s, background 0.2s",
                    }}
                  >
                    <span style={{ width: 22, height: 22, borderRadius: 6, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", border: on ? "none" : `1.5px solid ${C.border}`, background: on ? C.accent : "transparent", color: "#fff" }}>
                      {on && <Check size={13} />}
                    </span>
                    <span style={{ fontFamily: font, fontSize: 14.5, fontWeight: 600, color: C.text }}>{o}</span>
                  </button>
                );
              })}
            </div>
          </Field>
        )}

        <div style={{ display: "flex", gap: 12, marginTop: 4 }}>
          {step > 0 && (
            <button type="button" onClick={() => setStep(step - 1)} style={{ flex: "0 0 auto", padding: "14px 22px", borderRadius: 11, background: C.surface, border: `1.5px solid ${C.border}`, color: C.text, fontWeight: 700, fontFamily: font, fontSize: 15, cursor: "pointer" }}>
              Voltar
            </button>
          )}
          <button type="submit" disabled={submitDisabled} style={{ flex: 1, padding: 15, borderRadius: 11, background: C.accent, color: "white", fontWeight: 700, fontFamily: font, fontSize: 15, border: "none", cursor: submitDisabled ? "not-allowed" : "pointer", opacity: submitDisabled ? 0.5 : 1, boxShadow: "0 8px 24px rgba(5,96,255,0.28)" }}>
            {step < last ? "Avançar" : "Quero agendar minha demonstração"}
          </button>
        </div>

        <p style={{ fontFamily: font, fontSize: 12, color: C.muted, margin: 0, textAlign: "center", lineHeight: 1.5 }}>
          Passo {step + 1} de {STEPS.length} · Seus dados estão seguros e em conformidade com a LGPD.
        </p>
      </form>
    </>
  );
}
